import React, { memo } from "react";
import { Else, If, Then } from "react-if";
import CustomButton from "../../../../../components/customButton";
import CommonInput from "../../../../../components/commonFields";

import {
  FileIcon,
  TickIcon,
  deleteIcon,
  EditIcon,
  redCrossIcon,
  PreviewIcon,
} from "../../../../../assets/svg";

const SelectFileInner = (props) => {
  const {
    savedFiles,
    edit,
    selectedIndex,
    handleOnChange,
    handleCancel,
    handleSave,
    handlePreview,
    handleDelete,
    handleEdit,
    selectFile,
    isLoading,
    editDeleteAccess,
  } = props;

  return (
    <>
      <If condition={savedFiles?.length > 0}>
        <Then>
          <article className="select-file-list-wrapper">
            <ul className="select-file-list-container">
              {savedFiles?.map((item, index) => {
                return (
                  <li className="select-file-list">
                    {edit && selectedIndex === index ? (
                      <>
                        <section className="form-row">
                          <CustomButton
                            className={"cancel-button"}
                            btntype="clear"
                            title={<FileIcon />}
                          />
                          <CommonInput
                            placeholder="New Custom File Name"
                            className="custom-form-input"
                            onChange={handleOnChange}
                            defaultValue={item.fileNickName}
                          />
                        </section>

                        <section className="select-file-actions">
                          <CustomButton
                            btntype="clear"
                            className="ml-8 cancel-button"
                            onClick={handleCancel}
                            title={redCrossIcon}
                          />
                          <CustomButton
                            btntype="clear"
                            className="ml-8 cancel-button"
                            onClick={() => {
                              handleSave(item);
                            }}
                            title={<TickIcon />}
                          />
                        </section>
                      </>
                    ) : (
                      <>
                        <CustomButton
                          className={"mr-16 cancel-button file-info"}
                          btntype="clear"
                          title={
                            <div className="title">
                              <span className="icon">{<FileIcon />}</span>
                              <div className="file-details">
                                <span
                                  className="file-name"
                                  title={item.fileNickName}
                                >
                                  {item.fileNickName}
                                </span>
                              </div>
                            </div>
                          }
                        />
                        <section className="select-file-actions">
                          <CustomButton
                            testId='patient-file-delete-button'
                            btntype="clear"
                            className={editDeleteAccess !== 0 ? ` ml-8 cancel-button ${"danger-button"}` : 'disabled'}
                            disabled={editDeleteAccess === 0}
                            onClick={() => {
                              handleDelete(item);
                            }}
                            title={
                              <div
                                className={editDeleteAccess !== 0 ? ` file-action ${"danger-button"} ` : 'disabled'}
                              >
                                Delete {editDeleteAccess !== 0 && deleteIcon}
                              </div>
                            }
                          />
                          <CustomButton
                            testId='patient-file-edit-button'
                            btntype="clear"
                            className={editDeleteAccess !== 0 ? `ml-8 cancel-button` : 'disabled'}
                            onClick={() => {
                              handleEdit(index);
                            }}
                            disabled={editDeleteAccess === 0}
                            title={
                              <div className={editDeleteAccess !== 0 ? "file-action" : 'disabled'}>
                                Edit {editDeleteAccess !== 0 && <EditIcon />}
                              </div>
                            }
                          />
                          <CustomButton
                            btntype="clear"
                            className={`ml-8 cancel-button`}
                            onClick={() => {
                              handlePreview(item);
                            }}
                            title={
                              <div className="file-action">
                                Preview <PreviewIcon />
                              </div>
                            }
                          />
                          <CustomButton
                            btntype="clear"
                            title={
                              <div className="file-action">
                                Select <TickIcon />
                              </div>
                            }
                            className={`ml-8 cancel-button`}
                            onClick={() => {
                              selectFile(item);
                            }}
                          />
                        </section>
                      </>
                    )}
                  </li>
                );
              })}
            </ul>
          </article>
        </Then>{" "}
        <Else>
          <article className="select-file-list-wrapper">
            <ul className="select-file-list-container">
              {savedFiles.length === 0 &&
                !isLoading && (
                  <p className="no-data-message">No files have been saved.</p>
                )}
            </ul>
          </article>
        </Else>
      </If>
    </>
  );
};

export default memo(SelectFileInner);
